import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button, Icon, Table, Widget } from '@digital/ui';
import { getAllHistoricoUsuarioLogin, HistoricoUsuarioLogin } from '@app/api/usuario';

export interface ModalHistoricoAcessoUsuarioProps {
    usuarioId: string;
}

const ModalHistoricoAcessoUsuario = ({ usuarioId }: ModalHistoricoAcessoUsuarioProps) => {

    const [exibirModal, setExibirModal] = useState(false);
    const [resultListHistorico, setResultListHistorico] = useState<HistoricoUsuarioLogin[]>();



    useEffect(() => {
        if (exibirModal === true) {
            if (usuarioId) {
                getAllHistoricoUsuarioLogin(usuarioId).then((data) => {
                    setResultListHistorico(data);
                });
            }
        } else {
            setResultListHistorico(undefined);
        }
    }, [exibirModal, usuarioId]);

    const showModal = () => {
        setExibirModal(true);
    };

    const handleCancel = () => {
        setExibirModal(false);
    };

    return (
        <>
            <Tooltip title="Histórico de Acesso">
                <Button
                    onClick={() => {
                        showModal();
                    }}
                    icon="messaging-comments"
                />
            </Tooltip>
            <Modal
                title="Histórico de acesso"
                className="chat-modal"
                width={700}
                visible={exibirModal}
                onCancel={() => {
                    handleCancel();
                }}
                footer={[
                    <Button key="submit" type="primary" icon="commons-cancel" onClick={() => handleCancel()}>
                        Fechar
                    </Button>,
                ]}>
                <div className="chat-modal-message-box">
                    <Table
                        dataSource={resultListHistorico}
                        columns={[
                            {
                                title: 'N',
                                dataIndex: 'numeroLinha',
                            },
                            {
                                title: 'Data Hora',
                                dataIndex: 'dataHoLogin',
                            },
                            {
                                title: 'Login / Logoff',
                                dataIndex: 'entrada',
                                render: (text: any, record: HistoricoUsuarioLogin, index: number) => {
                                    return [<> {record.entrada === true ? 'Entrou' : 'Saiu'}</>]
                                }
                            }
                        ]}
                    />
                </div>


            </Modal>
        </>
    );
};

export default ModalHistoricoAcessoUsuario;
